
const Notifications = require('./js/model.js');

const Notification = require('./js/notification.js');
const PassiveNotification = require('./js/passive-notification.js');


module.exports = {
	Notifications: Notifications,
	Notification: Notification,
	PassiveNotification: PassiveNotification,
};


